<template>
  <div
    v-if="visibleView"
    id="app"
    class="d-flex flex-column min-vh-100 theme6"
    ref="baseBody"
  >
    <div>
      <Sidebar />
      <div class="main-content">
        <Header />
        <router-view style="padding-top: 70px" id="content-view" />
      </div>
    </div>
    <footer class="bg-dark text-center text-lg-start">
      <!-- Copyright -->
      <div
        class="text-center p-3 text-light"
        style="background-color: rgba(0, 0, 0, 0.2)"
      >
        Provided by Digitech - GEMS. ©️ {{ year }} PT. Golden Energy Mines, Tbk.
        <!-- <a class="text-dark" href="https://mdbootstrap.com/">MDBootstrap.com</a> -->
      </div>
      <!-- Copyright -->
    </footer>
  </div>
</template>

<script>
import Keycloak from "keycloak-js";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/Header.vue";
import lang from "@/lang.json";
import axios from "axios";
import moment from 'moment';
export default {
  data() {
    return {
      year: moment().format('YYYY'),
      AccessToken: "",
      keycloak: null,
      visibleView: false,
      kcOptions: {
        realm: process.env.VUE_APP_KEYCLOAK_REALM || "ugems",
        "auth-server-url": process.env.VUE_APP_KEYCLOAK_URL,
        url: process.env.VUE_APP_KEYCLOAK_URL,
        "ssl-required": "external",
        clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "ubudget",
        resource: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "ubudget",
        "verify-token-audience": true,
        "use-resource-role-mappings": true,
        "confidential-port": 0,
        "policy-enforcer": {},
      },
    };
  },
  components: {
    Sidebar,
    Header,
  },
  mounted() {
    this.keycloak = new Keycloak(this.kcOptions);
    this.authenticate();
  },
  methods: {
    authenticate: function () {
      this.AccessToken = "Authenticating....";

      this.keycloak
        .init({
          onLoad: "login-required",
        })
        .then(async (auth) => {
          if (!auth) {
            console.log("NOT Authenticated");
            this.AccessToken = "";
          } else {
            console.log("Authenticated");
            this.AccessToken = this.keycloak.token;
          }

          // test fetch
          // try {
          //   const resp = await axios.get(
          //     `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${
          //       process.env.VUE_APP_KEYCLOAK_REALM || "ugems"
          //     }/broker/google/token`,
          //     {
          //       headers: {
          //         Authorization: `Bearer ${this.keycloak.token}`,
          //       },
          //     }
          //   );
          //   console.log(resp);
          // } catch (err) {
          //   console.log("failed to get google token");
          // }

          localStorage.setItem("ugems-accessToken", this.keycloak.token);
          localStorage.setItem(
            "ugems-refreshToken",
            this.keycloak.refreshToken
          );
          localStorage.setItem(
            "ugems-tokenParsed",
            JSON.stringify(this.keycloak.tokenParsed)
          );

          this.visibleView = true;
          // this.identify();      
        })
        .catch((err) => {
          console.log("Authenticated Failed");
          console.log("err", err);
        });
    },
    
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";

@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
/* MY CUSTOM CSS */
@import url("./assets/css/mycustom.css");

.navbar-brand-img {
  max-width: 100% !important;
  max-height: 100% !important;
}
</style>
